import React from 'react';
import { ProductFilterOptions } from '@benzinga/content-manager';
import styled from '@benzinga/themetron';
import { Spinner } from '@benzinga/core-ui';
import { FilterItem } from './FilterItem';

export interface ProductFilterSelectProps {
  filterOptions?: ProductFilterOptions;
  onChangeGetProductData: (value: string, item: string) => void;
  productFilter?: {
    country?: boolean;
    account_size?: boolean;
    asset_type?: boolean;
  };
  preAppliedFilter?: {
    country?: string;
  };
  loadingData?: boolean;
}

export const ProductFilterSelect: React.FC<ProductFilterSelectProps> = ({
  filterOptions,
  loadingData,
  onChangeGetProductData,
  preAppliedFilter,
  productFilter,
}) => {
  return (
    <ProductFiltersWrap>
      {productFilter &&
        filterOptions &&
        Object.keys(productFilter).map(item => {
          if (productFilter[item] === true) {
            if (item == 'country' && preAppliedFilter?.country == '') {
              return (
                <>
                  {filterOptions?.countries && (
                    <FilterItem
                      label={'Country'}
                      onChangeGetProductData={onChangeGetProductData}
                      options={filterOptions.countries}
                      type={item}
                    />
                  )}
                </>
              );
            } else if (item == 'asset_type') {
              return (
                <>
                  {filterOptions?.asset_type && (
                    <FilterItem
                      label={'Asset Type'}
                      onChangeGetProductData={onChangeGetProductData}
                      options={filterOptions.asset_type}
                      type={item}
                    />
                  )}
                </>
              );
            } else if (item == 'account_size') {
              return (
                <>
                  {filterOptions?.account_size && (
                    <FilterItem
                      label={'Account Size'}
                      onChangeGetProductData={onChangeGetProductData}
                      options={filterOptions.account_size}
                      type={item}
                    />
                  )}
                </>
              );
            } else {
              return <></>;
            }
          } else {
            return <></>;
          }
        })}
      {loadingData && <Spinner />}
    </ProductFiltersWrap>
  );
};

export const ProductFiltersWrap = styled.div`
  display: block;
  width: 100%;
  .spinner {
    align-items: self-start;
  }
`;
